<template>
    <section id="home" class="section welcome-area bg-overlay overflow-hidden d-flex align-items-center">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-12 col-md-6 order-2 order-md-1">
                        <!-- Welcome Thumb -->
                        <div class="welcome-thumb mx-auto">
                            <img src="assets/img/welcome_mockup_2.png" alt="">
                        </div>
                    </div>
                    <!-- Welcome Intro Start -->
                    <div class="col-12 col-md-6 order-1 order-md-2">
                        <div class="welcome-intro px-0 px-lg-4">
                            <h1 class="text-white mb-2 mb-md-3">Get started in seconds.</h1>
                            <h3 class="text-white text-capitalize">Instant, site-wide monetization.</h3>
                            <p class="text-white mt-3 mb-4">Turnkey Web can add SourceSync to any website with a single line of code. You can even preview our product on your website using our Setup Extension (a browser plugin available for Chrome, Microsoft Edge and Firefox). Find potential issues, tweak settings and get the exact line you need in your next 15 minute break!</p>
                            <!-- Store Buttons -->
                            <div class="button-group store-buttons d-flex">
                                <a href="#" class="btn sApp-btn text-uppercase">Install Setup Extension</a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    
}
</script>

<style>

</style>